module.exports = __webpack_public_path__ + "static/quote1-a11b9db2f9a77666f2c6a7f4bac04da8.png";